/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};

/*
*  将图片转为base64格式
* */

const identification = {
  // 将图片转为base64格式
  transformBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function(e) {
        resolve(e.target.result)
      }
    })
  }
}
/**
 * 针对 input 对数字格式化 -- 限定只能输入整数和指定格式的小数
 * 分为 小数/整数
 * @param value ： 需要校验的数字
 * @param format：指定格式 小数或者整数  "8,4"|| "8"
 * @param field：需要跟新的自动
 * @param Obj：实体对象 例如表单对象--form
 */
export const formatInportData = (value,format,field,Obj) => {
  const formatArr = format.split(",");
  let regx2 = '';
  if (formatArr.length == 1) { // 说明当前校验的是整数
    // value = value.replace(/[^\d]/g,'');
    regx2=new RegExp(`^\\d{0,${formatArr[0]}}`);
  } else { // 小数
    regx2=new RegExp(`^\\d{0,${formatArr[0]}}(?:\\.\\d{0,${formatArr[1]}})?`);
    // value = value.toString().match(/^\d{0,8}(?:\.\d{0,4})?/);
  }
  value = value.toString().match(regx2);
  value = value[0];
  Obj[field] =  value;
  // 如果 数据不刷新，使用 set方法，目前使用没遇到问题
  // Vue.set([Obj],field,value)// 不能直接使用 this.$set
}

/**
 * 导出
 **/
export {
    timestampToTime,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    identification

}



// WEBPACK FOOTER //
// ./src/utils/util.js